<template>
  <div>
    <v-list-tile
      class="primary lighten-1"
      :key="order.id"
      ripple
      @click="$emit('order-selected', order)"
    >
      <v-list-tile-content>
        <v-list-tile-title>
          <b>{{ order.name }}</b>
        </v-list-tile-title>
        <v-list-tile-sub-title v-if="order.partner_id">{{
          order.partner_id[1]
        }}</v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ order.date_order }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <slot></slot>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider v-if="!lastItem" class="primary"></v-divider>
  </div>
</template>

<script>
export default {
  name: "OrderListItem",
  props: {
    order: Object,
    lastItem: Boolean
  },

  data() {
    return {
      e1: 0
    };
  }
};
</script>
